import { Component } from '@angular/core';

@Component({
  selector: 'icon-volume-off',
  standalone: true,
  template: `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.5 25.9001L21.475 22.8751C21.0583 23.1418 20.6166 23.3709 20.15 23.5626C19.6833 23.7543 19.2 23.9084 18.7 24.0251V21.9751C18.9333 21.8918 19.1625 21.8084 19.3875 21.7251C19.6125 21.6418 19.825 21.5418 20.025 21.4251L16.7 18.1001V23.3001L11.7 18.3001H7.69998V12.3001H10.9L6.09998 7.5001L7.49998 6.1001L25.9 24.5001L24.5 25.9001ZM24.3 20.1001L22.85 18.6501C23.1333 18.1334 23.3458 17.5918 23.4875 17.0251C23.6291 16.4584 23.7 15.8751 23.7 15.2751C23.7 13.7084 23.2416 12.3084 22.325 11.0751C21.4083 9.84176 20.2 9.00843 18.7 8.5751V6.5251C20.7666 6.99176 22.45 8.0376 23.75 9.6626C25.05 11.2876 25.7 13.1584 25.7 15.2751C25.7 16.1584 25.5791 17.0084 25.3375 17.8251C25.0958 18.6418 24.75 19.4001 24.3 20.1001ZM20.95 16.7501L18.7 14.5001V11.2501C19.4833 11.6168 20.0958 12.1668 20.5375 12.9001C20.9791 13.6334 21.2 14.4334 21.2 15.3001C21.2 15.5501 21.1791 15.7959 21.1375 16.0376C21.0958 16.2793 21.0333 16.5168 20.95 16.7501ZM16.7 12.5001L14.1 9.9001L16.7 7.3001V12.5001ZM14.7 18.4501V16.1001L12.9 14.3001H9.69998V16.3001H12.55L14.7 18.4501Z" fill="#609A9B"/>
    </svg>
  `,
  styles: [
   `
    svg {
        path {
          fill: var(--main-color);
        }
      }

      svg:hover {
        path {
          fill: var(--main-color-strong);
        }
      }
    `
  ]
})

export class VolumeOffIconComponent {

}
